import httpStore from "@/api/httpStore.js";
import decamelizeKeysDeep from "decamelize-keys-deep";

// En la base la imagen faltante llega como NULL o como string vacío.
export function hasImage(url) {
  return !!(url && String(url).trim());
}

export function getCategories() {
  return httpStore
    .get("categories")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
export function getSubcategories(categoryId) {
  return httpStore
    .get("categories/subcategories/" + categoryId)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function deleteCategoryImage(categoryId) {
  return httpStore
    .get("categories/image/" + categoryId)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function updateCategory(categoryId, newCategory) {
  newCategory = decamelizeKeysDeep(newCategory);
  return httpStore
    .put(`categories`, {
      categoryId: categoryId,
      newCategory: newCategory
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function updateSubCategory(subcategoryId, newCategory) {
  newCategory = decamelizeKeysDeep(newCategory);
  return httpStore
    .put(`categories/subcategory`, {
      subcategoryId: subcategoryId,
      newCategory: newCategory
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function requestDeleteSubcategory(id) {
  return httpStore
    .delete(`categories/subcategory/${id}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return {
        status: "error",
        message: e.response?.data?.message || e.message
      };
    });
}

export function requestDeleteCategory(id) {
  return httpStore
    .delete(`categories/category/${id}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return {
        status: "error",
        message: e.response?.data?.message || e.message
      };
    });
}

export function getCategoriesForPart(unificado) {
  return httpStore
    .get(`products/categories/${unificado}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function addCategoryToProduct(unificado, subcategoryId) {
  return httpStore
    .post(`products/category`, {
      unificado: unificado,
      subcategoryId: subcategoryId
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function deleteCategoryFromProduct(relationId) {
  return httpStore
    .delete(`products/category/${relationId}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getItemsInCategory(subcategoryId) {
  return httpStore
    .get(`categories/items/${subcategoryId}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
